<template>
	<img
		v-if="isExternal"
		:class="imgClass"
		:src="src"
		:width="width"
		:height="height"
		:alt="alt"
		:loading="loading"
	>
	<template v-else>
		<LazyNuxtPicture
			v-if="element === 'picture'"
			:img-attrs="{
				class: imgClass,
				itemprop: 'image',
			}"
			densities="x1 x2"
			:placeholder="placeholderSrc"
			:src="src"
			:width="width"
			:height="height"
			:alt="alt"
			:fit="fit"
			:quality="quality"
			:modifiers="modifiers"
			:preset="preset"
			:preload="preload"
			:loading="loading"
		/>
		<LazyNuxtImg
			v-else
			:class="imgClass"
			:placeholder="placeholderSrc"
			:src="src"
			:width="width"
			:height="height"
			:alt="alt"
			:fit="fit"
			:quality="quality"
			:modifiers="modifiers"
			:preset="preset"
			:preload="preload"
			:loading="loading"
			:sizes="sizes"
		/>
	</template>
</template>

<script lang="ts" setup>
import type { ImageFitType } from '#base/core/types/ImageFitType';

const {
	element = 'img',
	alt,
	src,
	placeholderSrc,
	width,
	height,
	preload = false,
	imgClass,
	fit = 'cover',
	quality = 75,
	modifiers,
	preset,
	loading = 'eager',
	sizes = '100vw xl:75vw xxl:50vw',
} = defineProps<{
	element?: 'img' | 'picture';
	alt: string;
	src: string;
	placeholderSrc?: string;
	width?: number;
	height?: number;
	preload?: boolean;
	imgClass?: string | string[];
	fit?: ImageFitType;
	quality?: number;
	modifiers?: {
		[key: string]: unknown;
	};
	preset?: string;
	loading?: 'eager' | 'lazy';
	sizes?: string;
}>();

const isExternal = src.startsWith('http');
</script>
